import React from 'react';

import Button from '../../forms/button/Button';
import Modal from './Modal';

interface IOwnState {
    show: boolean;
    buttonsClickable: boolean;
    onAccept: (e: React.FormEvent<HTMLButtonElement> | React.MouseEvent<HTMLElement>) => void;
    onReject?: (e: React.FormEvent<HTMLElement> | React.MouseEvent<HTMLElement> | KeyboardEvent) => void;
    acceptText?: string;
}

type Props = IOwnState;

class ConfirmationModal extends React.Component<Props, {}> {
    public render() {
        return <Modal onClose={this.onClose} show={this.props.show}>
            <div className="rich-text">
                {this.props.children}
            </div>

            <div className="modal__content__form__actions action-buttons a--right">
                <Button modifierClass="button--small" onClick={this.props.onReject} disabled={!this.props.buttonsClickable} type="button">Annuller</Button>
                <Button modifierClass="button--primary button--small" onClick={this.props.onAccept} disabled={!this.props.buttonsClickable} spinning={!this.props.buttonsClickable}>{this.props.acceptText || 'OK'}</Button>
            </div>
        </Modal>;
    }

    private onClose = (e: React.FormEvent<HTMLElement> | React.MouseEvent<HTMLElement> | KeyboardEvent) => {
        if (this.props.buttonsClickable && this.props.onReject) {
            this.props.onReject(e);
        }
    }
}

export default ConfirmationModal;